<template>
  <div class="login-card">
    <p class="card-title">{{ $t('reset_resetPassword') }}</p>
    <template v-if="step === 0">
      <b-form @submit="onSubmit(1, $event)">
        <b-form-group class="mb-1" label="Email" label-class="label-class">
          <input :placeholder="$t('reset_enterYourEmail')" class="form-control px-5" v-model="email"
            autocomplete="off" />
          <i class="fas fa-envelope input-icon"></i>
        </b-form-group>
        <p class="email-descrip">{{ $t('reset_verificationCodeSentToThisEmail') }}</p>
        <b-button type="submit" class="w-100 btn-submit">{{ $t('reset_sendVerificationCode') }}</b-button>
      </b-form>
    </template>

    <template v-else-if="step === 1">
      <b-form @submit="onSubmit(2, $event)">
        <b-form-group :label="$t('reset_enterVerificationCode')" label-class="label-class">
          <div class="input-group">
            <b-form-input :placeholder="$t('reset_PenterVerificationCode')" v-model="code" autocomplete="off"
              class="pl-5"></b-form-input>
            <i class="fas fa-lock input-icon"></i>
            <div class="input-group-append"><span class="input-group-text"></span></div>
          </div>
        </b-form-group>
        <b-form-group :label="$t('reset_newPassword')" label-class="label-class">
          <div class="input-group">
            <b-form-input :type="`${showPass ? 'text' : 'password'}`" :placeholder="$t('reset_enterNewPassword')"
              v-model="newPass" autocomplete="off" class="pl-5"></b-form-input>
            <i class="fas fa-shield input-icon"></i>
            <div class="input-group-append">
              <span class="input-group-text py-0" style="cursor: pointer" @click="showPass = !showPass">
                <i v-if="showPass" class="fas fa-eye"></i>
                <i v-else class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </b-form-group>
        <b-form-group :label="$t('reset_confirmNewPassword')" label-class="label-class">
          <div class="input-group mb-3">
            <b-form-input :type="`${showPassRe ? 'text' : 'password'}`" autocomplete="off"
              :placeholder="$t('reset_PconfirmNewPassword')" class="pl-5"></b-form-input>
            <i class="fas fa-shield input-icon"></i>
            <div class="input-group-append">
              <span class="input-group-text py-0" style="cursor: pointer" @click="showPassRe = !showPassRe">
                <i v-if="showPassRe" class="fas fa-eye"></i>
                <i v-else class="fas fa-eye-slash"></i>
              </span>
            </div>
          </div>
        </b-form-group>
        <b-button class="w-100 btn-submit" type="submit">{{ $t('reset_complete') }}</b-button>
      </b-form>
    </template>

    <template v-else-if="2">
      <div class="text-center">
        <!-- <img src="assets/image/Confirmed-rafiki 1.svg" /> -->
        <p class="mt-3 mb-1 content-main"><strong>{{ $t('reset_congratulations') }}</strong></p>
        <p class="content">{{ $t('reset_passwordResetSuccessfully') }}</p>
        <b-button class="w-100 btn-submit" type="submit" to="/"> {{ $t('reset_returnToLogin') }} </b-button>
      </div>
    </template>
  </div>
</template>

<script>
import RepositoryFactory from "@/repository/factory";
const authCustomer = RepositoryFactory.get("authCustomer");
export default {
  data() {
    return {
      step: 0,
      email: null,
      code: null,
      newPass: null,
      showPass: false,
      showPassRe: false,
    };
  },
  methods: {
    async onSubmit(value, event) {
      event.preventDefault();
      if (value === 1) {
        let body = {
          AppCode: "VGAS247",
          UserEmail: this.email,
        };
        let res = await authCustomer.SendCodeForgetPassword(body);
        this.step = value;
      } else if (value === 2) {
        let body = {
          AppCode: "VGAS247",
          UserEmail: this.email,
          SecurityCode: this.code,
          UserPassNew: this.newPass,
        };
        let res = await authCustomer.ChangePasswordBySecurityCode(body);
        this.step = value;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-card {
  border-radius: var(--Border-radius-rounded-xl, 12px);
  background: rgba(255, 255, 255, 0.75);
  backdrop-filter: blur(25px);
  padding: 16px;
  margin: 0 auto;
  max-width: 416px;
}

.card-title {
  color: var(--Blue-navy---Web, #0c2d57);
  text-align: center;
  /* text-24/font-semibold */
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  /* 36px */
}

.input-icon {
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 20px;
  z-index: 9;
  transform: translateY(-50%);
  color: #6b6f80;
}

.btn-submit {
  padding: 12px 16px;
  border-radius: 8px;
  background: var(--brand-color, #ff9500) !important;
}

.email-descrip {
  color: var(--System-Colors-Gray, #6b6f80);

  /* text-14/font-regular */
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  /* 157.143% */
}

.input-icon {
  font-size: 15px;
  position: absolute;
  top: 50%;
  left: 20px;
  z-index: 9;
  transform: translateY(-50%);
  color: #6b6f80;
}
</style>